<template>
  <v-app>

    <v-card class="overflow-hidden content-card">
      <Menu v-bind:offset="offsetTop" />
      <v-sheet
              id="scrolling-content"
              class="overflow-y-auto"
              height="100%"

      >
        <v-container fluid style="height: 100vh;padding:0">
          <div :style="paddingTop">
            <v-alert
                    v-if="alert.message"
                    v-model="alert.show"
                    :dismissible="alert.dismissible"
                    :type="`${alert.type}`"
                    class="mb-0"
                    tile
                    :icon="alertIcon"
            >
              {{alert.message}}
            </v-alert>
            <router-view transition="fade-transition" v-scroll:#scrolling-content="onScroll" :offsetTop="offsetTop"></router-view>
          </div>

        </v-container>
      </v-sheet>
    </v-card>

<!--      <v-scroll-x-reverse-transition hide-on-leave>-->
<!--          <div id="activ8" v-if="offsetTop > 100 && this.$route.name !== 'sign-up-promo'" class="d-none d-md-flex">-->
<!--              <v-tooltip bottom>-->
<!--                  <template v-slot:activator="{ on }">-->
<!--                      <v-img-->
<!--                              v-on="on"-->
<!--                              class="white&#45;&#45;text align-end activ8-logo elevation-4"-->
<!--                              width="150px"-->
<!--                              height="70px"-->
<!--                              @click="navigate('activate')"-->
<!--                              :src="activ8Logo"-->
<!--                              eager-->
<!--                      >-->
<!--                      </v-img>-->
<!--                  </template>-->
<!--                  <span>Activate your tags</span>-->
<!--              </v-tooltip>-->

<!--          </div>-->
<!--      </v-scroll-x-reverse-transition>-->

      <!-- dummy image to force preload-->
<!--      <v-img-->
<!--              class="d-none"-->
<!--              :src="activ8Logo"-->
<!--              eager-->
<!--      >-->
<!--      </v-img>-->




<!--      <v-container class="main-content">-->
<!--        <v-layout-->
<!--                align-center-->
<!--                justify-center-->
<!--        >-->
<!--          <v-flex text-center>-->
<!--            <v-alert-->
<!--                    v-if="alert.message"-->
<!--                    v-model="alert.show"-->
<!--                    :dismissible="alert.dismissible"-->
<!--                    :type="`${alert.type}`"-->
<!--                    class="mb-4"-->
<!--            >-->
<!--              {{alert.message}}-->
<!--            </v-alert>-->
<!--            <router-view transition="fade-transition"></router-view>-->

<!--          </v-flex>-->
<!--        </v-layout>-->
<!--      </v-container>-->

<!--    <v-content>-->
<!--      <v-container-->
<!--              fluid-->
<!--              fill-height-->
<!--      >-->
<!--        <v-layout-->
<!--                align-center-->
<!--                justify-center-->
<!--        >-->
<!--          <v-flex text-center>-->
<!--            <v-alert-->
<!--                    v-if="alert.message"-->
<!--                    v-model="alert.show"-->
<!--                    :dismissible="alert.dismissible"-->
<!--                    :type="`${alert.type}`"-->
<!--                    class="mb-4"-->
<!--            >-->
<!--              {{alert.message}}-->
<!--            </v-alert>-->
<!--            <router-view transition="fade-transition"></router-view>-->

<!--          </v-flex>-->
<!--        </v-layout>-->
<!--      </v-container>-->
<!--    </v-content>-->

  </v-app>
</template>

<script>
    import Menu from './components/Menu'
    import { mapState, mapActions } from 'vuex'
    import { store } from './store';
    import { Scroll } from 'vuetify/lib/directives'
    import VueGtag from "vue-gtag";
    import Vue from "vue";
    import {i18n} from "./i18n";

    let activ8Logo = require('@/assets/activ8-logo.png')

    export default {
        name: 'App',
        directives: {
          Scroll
        },
        data: () => ({
            drawer: true,
            offsetTop: 0,
            activ8Logo: activ8Logo,
            items: [
              {
                src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg',
              },
              {
                src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
              },
              {
                src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
              },
              {
                src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
              },
            ],
        }),
        components: {
            'Menu': Menu
        },
        computed: {
            ...mapState({
                basket: state => state.basket,
                alert: state => state.alert,
                authenticated: state => state.authenticated,
                user: state => state.account.user,
                validationErrors: state => state.validationErrors,
                brand: state => state.brand,
                locale: state => state.locale
            }),
            paddingTop () {
                if (this.$vuetify.breakpoint.name === 'xs') {
                    return 'paddingTop: 80px'
                }

                return 'paddingTop: 120px'
            },
            alertIcon() {
                if (this.alert) {
                    return alert.icon
                }

                return null
            }
        },
        methods: {
            ...mapActions({
                clearAlert: 'alert/clear'
            }),
            onScroll (e) {
              this.offsetTop = e.target.scrollTop
            },
            navigate (routeName) {
              this.$router.push({name: routeName})
            }
        },
        watch: {
            $route (to, from){
                // clear alertModule on location change
                if (from.name !== 'login') {
                    this.clearAlert();
                }
            }
        },
        mounted() {

          i18n.locale = this.locale

          if (this.brand === 'neotag') {
            const favicon = document.getElementById("favicon");
            let urlsplit = favicon.href.split("/");
            favicon.href = urlsplit[0] + '//' + urlsplit[2] + '/favicon-neotag.png'
          }

          if (store.state.account.user && store.state.account.user.token) {
            store.commit('loggedIn')
          }

          let cookieAccept = localStorage.getItem('vue-cookie-accept-decline-myPanel1');
          console.log(cookieAccept)

          // for returning users check for cookie accept and enable gtag
          if (cookieAccept === 'accept') {
            Vue.use(VueGtag, {
              config: { id: "UA-32748279-2" },
              enabled: true
            });
            this.$gtag.optIn()

            // hotjar script
            if (process.env.NODE_ENV === 'production') {
              this.$loadScript("/hotjar.js")
                  .then(() => {
                    // Script is loaded, do something
                  })
                  .catch(() => {
                    // Failed to fetch script
                  });
            }
          }
        }
    };
</script>

<style>
  .contain-width {
    max-width: 1500px !important;
  }
  .grey-container {
    background-color: #E6E6E6;
  }

  body .v-application a,
  body .v-application .display-1,
  body .v-application .text-h1,
  body .v-application .text-h2,
  body .v-application .text-h3,
  body .v-application .text-h4,
  body .v-application .text-h6,
  body .v-application .headline,
  body .v-application div,
  body .v-application h1 {
      font-family: 'Rubik', sans-serif !important;
  }
  body .v-application .display-1, body .v-application .headline {
      font-weight: bold;
  }
  .v-btn--fab.v-btn--fixed, .v-btn--fab.v-btn--absolute {
      z-index: 1 !important;
  }
  .v-card__title {
      word-break: normal !important;
  }
  button.small {
      border-radius: 12px !important;
      text-transform: none !important;
  }
  .v-btn__content {
      font-weight: bold !important;
  }
  footer .container {
    padding-top: 0;
    padding-bottom: 0;
  }
  footer .v-list--dense .v-list-item  {
    min-height: 25px;
  }
  footer .copyright {
    padding-top: 10px
  }
  .content-card {
    border-radius: 0 !important;
  }
  .form-card {
    border-radius: 15px !important;
    border: none !important;
    padding: 10px !important;
  }
  #activ8 {
      background: transparent;
      position: fixed;
      bottom: 16px;
      right: 16px;

  }
  #activ8 .activ8-logo {
      border: solid 16px white;
      margin: 4px;
      border-radius: 8px !important;
      cursor: pointer;
      background-color: #fff;
  }
  .scroll-x-reverse-transition-enter-active {
      animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
      transform: translate3d(0, 0, 0);
      backface-visibility: hidden;
      perspective: 1000px;
  }

  @keyframes shake {
      10%, 90% {
          transform: translate3d(-1px, 0, 0);
      }

      20%, 80% {
          transform: translate3d(2px, 0, 0);
      }

      30%, 50%, 70% {
          transform: translate3d(-4px, 0, 0);
      }

      40%, 60% {
          transform: translate3d(4px, 0, 0);
      }
  }
</style>

